import { render, staticRenderFns } from "./TransactionIndexView.vue?vue&type=template&id=15b55483&scoped=true&"
import script from "./TransactionIndexView.vue?vue&type=script&lang=js&"
export * from "./TransactionIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b55483",
  null
  
)

export default component.exports